import React from "react";
import Header from "../../common/Header";
import user_icn from "../../../../assets/images/societies-icn.svg";
import { Table, Select } from "antd";
import { BiExport } from "react-icons/bi";

const ToBeRegisteredComponent = (props) => {
  const {
    unregisteredFlatsList,
    user_table_columns,
    handleClearFilters,
    filteredData,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    wingList,
    handleWingChange,
    selectedWingId,
    handleExportData,
    isClearDisabled,
  } = props;

  return (
    <>
      <Header title="To Be Registered" />
      <div className="user-main">
        <div className="user-first">
          <div className="left-section">
            <h1>Flat List</h1>
            <p className="dec-text">
              This section provides information about your society's flat's
              list, which is yet to be registered.
            </p>
          </div>
          <div className="right-section">
            <div className="card-1 card">
              <img src={user_icn} alt="" />
              <div className="details">
                <h1>{unregisteredFlatsList?.length || 0}</h1>
                <p>Unregistered Flats</p>
              </div>
            </div>
          </div>
        </div>
        <div className="user-second">
          <div className="left-section">
            <Select
              placeholder="Select Wing"
              allowClear
              onChange={handleWingChange}
              value={selectedWingId}
            >
              {wingList.map((wing) => (
                <Select.Option key={wing.wingId} value={wing.wingId}>
                  {wing.wingName}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="right-section">
            <button onClick={handleExportData}>
              <BiExport />
              Export
            </button>
            <button onClick={handleClearFilters} disabled={isClearDisabled}>
              Clear
            </button>
          </div>
        </div>
        <div className="user-list">
          <Table
            columns={user_table_columns}
            dataSource={filteredData}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: filteredData.length,
              position: ["bottomCenter"],
              showSizeChanger: true,
              onChange: (page, size) => {
                setCurrentPage(page);
                setPageSize(size);
              },
            }}
            rowKey={(record, index) => index}
            scroll={{ x: "max-content" }}
          />
        </div>
      </div>
    </>
  );
};

export default ToBeRegisteredComponent;
